<template>
	<div class="index flex1 ">
		<div class="header colFFF ">{{language=='cn'?'产品中心':'Product Core'}} </div>
		<div class="list f-a wrap ">
			<div class="item pointer" v-for="(item, index) in getCategory.list"
			@click="toDetail(item)">
				<img :src="item.home[0]" alt="" />
				<div class="title f-a-j">{{ item.title}}</div>
				<el-button type="primary" plain style="width: 100%;">查看详情</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import { category_list } from '@/data/data.js';
export default {
	props:{
		index:{
			type:Number,
			default:1
		}
	},
	data() {
		return {
			category_list,
			icon: require('@/assets/image/精油水薰衣草/1.jpg')
		};
	},
	computed: {
		getCategory() {
			return this.category_list[this.index];
		},
		language(){
			return this.$store.state.language
		}
	},
	methods:{
		toDetail(item){
			this.$router.push({
				path:`/category/detail/${item.id}`
			})
		}
	}
};
</script>

<style lang="less" scoped>


.index {
	padding-top: 0;
	box-sizing: border-box;
	.header {
		line-height: 56px;
		height: 56px;
		text-indent: 10px;
		background-color: #b3c0d1;
	}
	.list {
		padding: 0 30px;
		.item {
			margin-left: 20px;
			border: 1px solid #ebeef5;
			width: 300px;
			margin-top: 18px;
			border-radius: 4px;
			transition: 0.5s;
			box-sizing: border-box;
			padding: 12px;
			img {
				display: block;
				width: 100%;
				height: 300px;
				margin: 0 auto;
			}
			.title {
				height: 40px;
				line-height: 40px;
			}
			.el-button{
				width: 100%;
				letter-spacing: 1px;
				margin-top: 10px;
			}
		}
		.item:nth-child(n + 2) {
		}
	}
}

</style>
